import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ChevronDown, LifeBuoy, LogOut, User } from "lucide-react";
import { actions } from "redux/User/action";

const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");

const AccountMenu = ({ user }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => !ref.current?.contains(e.target) && setOpen(false);
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  const logOut = () => {
    setOpen(false);
    dispatch(actions.userLogout(navigate));
    localStorage.removeItem("TOKEN");
  };

  return (
    <div className="cc-account" ref={ref}>
      <button
        type="button"
        className="cc-account__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className="cc-avatar">
          {user?.image ? <img src={user.image} alt="" /> : initials(user?.name) || <User size={16} />}
        </span>
        <span className="cc-account__text">
          <span className="cc-account__name">{user?.name}</span>
          {user?.designation && <span className="cc-account__role">{user.designation}</span>}
        </span>
        <ChevronDown size={16} className="cc-account__chevron" aria-hidden="true" />
      </button>

      {open && (
        <div className="cc-menu" role="menu">
          <div className="cc-menu__header">
            <p className="cc-menu__label">Signed in as</p>
            <p className="cc-menu__email">{user?.email}</p>
          </div>
          <button type="button" role="menuitem" className="cc-menu__item" onClick={() => go("/profile")}>
            <User size={16} aria-hidden="true" /> Your profile
          </button>
          <button type="button" role="menuitem" className="cc-menu__item" onClick={() => go("/support")}>
            <LifeBuoy size={16} aria-hidden="true" /> Support
          </button>
          <div className="cc-menu__divider" />
          <button type="button" role="menuitem" className="cc-menu__item cc-menu__item--danger" onClick={logOut}>
            <LogOut size={16} aria-hidden="true" /> Log out
          </button>
        </div>
      )}
    </div>
  );
};

export default AccountMenu;
